import {Color} from '../enums/color';
import {Rule} from '../models/svg-rule/rule.model';

export const createColorRule = (
  target: string,
  conditionFn: (
    wagonIndex: number,
    data: any[],
    setColor: (color: Color) => void
  ) => boolean
): Rule => {
  let color: Color | null = null;
  return {
    condition(wagonIndex: number, data: any[]) {
      return conditionFn(wagonIndex, data, (c: Color) => (color = c));
    },
    get color() {
      return color;
    },
    target
  };
};

export const createTextRule = (
  target: string,
  conditionFn: (
    wagonIndex: number,
    data: any[],
    setColor: (color: Color) => void,
    setText: (text: string) => void,
    setPosition?: (pos: string) => void,
    setTextAnchor?: (anchor: string) => void
  ) => boolean,
  options: {
    idToAdd?: string;
    classNameToAdd?: string;
    fontSize: string;
    fontFamily: string;
    fontStyle: string;
    fontWeight: string;
    offsetX: number;
    offsetY: number;
    position?: string;
    textAnchor?: string;
    maxWidth?: number;
    lineHeight?: number;
  }
): Rule => {
  let color: Color | null = null;
  let text: string | null = null;
  let position: string = options.position ?? 'right';
  let textAnchor: string = options.textAnchor ?? 'middle';

  const {position: _, textAnchor: __, ...restOptions} = options;

  return {
    condition(wagonIndex: number, data: any[]) {
      return conditionFn(
        wagonIndex,
        data,
        (c: Color) => color = c,
        (t: string) => text = t,
        (p?: string) => {
          if (p) position = p;
        },
        (a?: string) => {
          if (a) textAnchor = a;
        }
      );
    },
    get color() {
      return color;
    },
    get displayText() {
      return text ?? '-';
    },
    get position() {
      return position;
    },
    get textAnchor() {
      return textAnchor;
    },
    target,
    ...restOptions
  };
};

export const createIconRule = (
  target: string,
  conditionFn: (
    systemId: string,
    wagonIndex: number,
    data: any[],
    setColor: (color: Color) => void,
    setIcon: (icon: string) => void,
    setIconType?: (iType: string) => void,
    setPosition?: (pos: string) => void
  ) => boolean,
  options: {
    idToAdd?: string;
    classNameToAdd?: string;
    iconType?: string;
    iconSize: number;
    offsetX: number;
    offsetY: number;
    position?: string;
  }
): Rule => {
  let color: Color | null = null;
  let icon: string | null = null;
  let iconType: string | null = options.iconType ?? null;
  let position: string | null = options.position ?? 'right';

  const {iconType: _, position: __, ...restOptions} = options;

  return {
    condition(systemId: string, wagonIndex: number, data: any[]) {
      return conditionFn(
        systemId,
        wagonIndex,
        data,
        (c: Color) => color = c,
        (i: string) => icon = i,
        (iType?: string) => {
          if (iType) iconType = iType;
        },
        (p?: string) => {
          if (p) position = p;
        }
      );
    },
    get color() {
      return color;
    },
    get icon() {
      return icon;
    },
    get iconType() {
      return iconType;
    },
    get position() {
      return position;
    },
    target,
    ...restOptions
  };
};
